import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import apiClient from "../Config/apiConfig";
import { LineWave } from "react-loader-spinner";
const config = {
  BASE_URL: "https://admin.thezeeshangroup.com/",
};
const Quality = () => {
  const [getqualityData, setGetqualityData] = useState([]);
  const [loader, setLoader] = useState(true);
  const qualitypageApi = async () => {
    try {
      const res = await apiClient.get(`api/quality-health-safety-and-environment`);
      setGetqualityData(res.data);
      setLoader(false);
    } catch (error) {
      console.log(error.message);
    }
  };
  useEffect(() => {
    qualitypageApi();
  }, []);
  return (
    <>
      <div>
        {loader ? (
          <div className="d-flex justify-content-center">
            <LineWave
              height="250"
              width="150"
              color="#56b13d"
              ariaLabel="line-wave"
            />
          </div>
        ) : (
          getqualityData && (
            <div>
              <div className="title-bar-wrapper">
                <Container>
                  <Row>
                    <div className="title">
                      <h1>QHSE</h1>
                    </div>
                    <ul className="bread-crumb pull-right">
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>-</li>
                      <li>QHSE</li>
                    </ul>
                  </Row>
                </Container>
              </div>
              <div className="quality-policy">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-7 col-md-12">
                      <div className="pbmit-heading-subheading">
                        <h4 className="pbmit-subtitle">{getqualityData.titleone}</h4>
                        <h2 className="pbmit-title text-left mb-4">
                          {getqualityData.subtitleone}
                        </h2>
                      </div>
                      <div dangerouslySetInnerHTML={{ __html: getqualityData.descone }} />

                    </div>
                    <div className="col-lg-5 col-md-12">
                      <img
                        src={`${config.BASE_URL}uploads/${getqualityData.certificateone}`}
                        alt={getqualityData.titleone}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="quality-policy hse">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-5 col-md-12">
                      <img
                        src={`${config.BASE_URL}uploads/${getqualityData.certificatetwo}`}
                        alt={getqualityData.titleone}
                      />
                    </div>
                    <div className="col-lg-7 col-md-12">
                      <div className="pbmit-heading-subheading">
                        <h4 className="pbmit-subtitle">{getqualityData.titletwo}</h4>
                        <h2 className="pbmit-title text-left mb-4">
                          {getqualityData.subtitletwo}
                        </h2>
                      </div>
                      <div dangerouslySetInnerHTML={{ __html: getqualityData.desctwo }} />

                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </>
  );
};

export default Quality;
